const autoNgTemplateLoaderTemplate1 = require('./templateItem.html');

import angular from 'angular';

import './template-item.css';

angular.module('shbdeployer.app').component('templateItem', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    model: '<',
    typeLabel: '@',
    onSelect: '<',
  },
  transclude: {
    actions: '?templateItemActions',
  },
});
